import http from '../jslibs/axios/http';

//首页服务列表
export  const getServiceList = () => (http.get('/v1/cms/ServerInfo'));

//首页服务详情
export  const getServiceDetail = id => (http.get(`/v1/cms/ServerInfo/${id}`));

//编辑服务
export  const editService = data => (http.put(`/v1/cms/ServerInfo/${data.id}`, data));